export default "__VITE_ASSET__BnQWYAZC__"